import React from 'react';
import { Caption } from '~/shared/Typography';
import { useTheme } from '@springbig/shared';
import { SpIcon } from '~/shared/Icon';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { Modal } from '~/shared/Theme';

const SuspendedMerchantScreen = () => {

    const { primary } = useTheme();

    return (
        <Modal isOpen>
            <Modal.Header alignItems={'center'}>
                <SpIcon icon={faTriangleExclamation} color={primary} size={72} />
            </Modal.Header>
            <Modal.Body textAlign={'center'} pb={4}>
                <Caption text={'suspended_account.disclaimer'} />
            </Modal.Body>
        </Modal>
    );
};

export default SuspendedMerchantScreen;
